import Rails from '@rails/ujs';
import DraggableTable from '../utils/DraggableTable';

export default class BackofficeSatisfactionFormTemplatesShow extends DraggableTable {
  constructor() {
    super('sortable-fields');
    this.bindEvents();
  }

  updateOrder() {
    const rows = document.querySelectorAll(`#${this.tableId} tr`);
    const ids = Array.from(rows).map(row => row.dataset.id);
    const reorderUrl = document.getElementById('fields-container').dataset.reorderUrl;

    const params = new URLSearchParams();
    ids.forEach(id => params.append('positions[]', id));

    Rails.ajax({
      url: reorderUrl,
      type: 'PATCH',
      data: params.toString(),
      success: () => {
        this.showNotification('success', 'Ordre des champs mis à jour');
      },
      error: () => {
        this.showNotification('error', 'Erreur lors de la mise à jour de l\'ordre');
        window.location.reload();
      }
    });
  }

  bindEvents() {
    // Delete field confirmation
    $(document).on('click', '.delete-field-btn', this.handleDeleteField.bind(this));
    
    // Archive template confirmation
    $(document).on('click', '.archive-template-btn', this.handleArchiveTemplate.bind(this));
    
    // Duplicate template
    $(document).on('click', '.duplicate-template-btn', this.handleDuplicateTemplate.bind(this));
    
    // Publish template
    $(document).on('click', '.publish-template-btn', this.handlePublishTemplate.bind(this));
  }

  handleDeleteField(event) {
    event.preventDefault();
    const $btn = $(event.currentTarget);
    const url = $btn.data('url');
    const confirmMessage = $btn.data('confirm');
    
    if (confirm(confirmMessage)) {
      Rails.ajax({
        url: url,
        type: 'DELETE',
        success: () => {
          $btn.closest('.field-item').fadeOut(300, function() {
            $(this).remove();
          });
          this.showNotification('success', 'Champ supprimé');
        },
        error: () => {
          this.showNotification('error', 'Erreur lors de la suppression');
        }
      });
    }
  }

  handleArchiveTemplate(event) {
    event.preventDefault();
    const $btn = $(event.currentTarget);
    const url = $btn.data('url');
    const confirmMessage = $btn.data('confirm');
    
    if (confirm(confirmMessage)) {
      Rails.ajax({
        url: url,
        type: 'PATCH',
        success: (data) => {
          this.showNotification('success', data.message || 'Modèle archivé');
          setTimeout(() => window.location.reload(), 1000);
        },
        error: () => {
          this.showNotification('error', 'Erreur lors de l\'archivage');
        }
      });
    }
  }

  handleDuplicateTemplate(event) {
    event.preventDefault();
    const $btn = $(event.currentTarget);
    const url = $btn.data('url');
    
    $btn.prop('disabled', true);
    
    Rails.ajax({
      url: url,
      type: 'POST',
      success: (data) => {
        this.showNotification('success', data.message || 'Modèle dupliqué');
        if (data.redirect_url) {
          setTimeout(() => window.location.href = data.redirect_url, 1000);
        }
      },
      error: () => {
        this.showNotification('error', 'Erreur lors de la duplication');
        $btn.prop('disabled', false);
      }
    });
  }

  handlePublishTemplate(event) {
    event.preventDefault();
    const $btn = $(event.currentTarget);
    const url = $btn.data('url');
    
    $btn.prop('disabled', true);
    
    Rails.ajax({
      url: url,
      type: 'PATCH',
      success: (data) => {
        this.showNotification('success', data.message || 'Modèle publié');
        setTimeout(() => window.location.reload(), 1000);
      },
      error: (xhr) => {
        let message = 'Erreur lors de la publication';
        try {
          const response = JSON.parse(xhr.response);
          if (response.message) message = response.message;
        } catch(e) {
          // Ignore parse errors
        }
        this.showNotification('error', message);
        $btn.prop('disabled', false);
      }
    });
  }

  showNotification(type, message) {
    if (typeof $.NotificationApp !== 'undefined') {
      $.NotificationApp.send(
        type === 'success' ? 'Succès' : (type === 'warning' ? 'Attention' : 'Erreur'),
        message,
        'top-right',
        'rgba(0,0,0,0.2)',
        type
      );
    } else {
      alert(message);
    }
  }

  onDataChanged(data) {
  }

  onDestroy() {
    $(document).off('click', '.delete-field-btn');
    $(document).off('click', '.archive-template-btn');
    $(document).off('click', '.duplicate-template-btn');
    $(document).off('click', '.publish-template-btn');
  }
}
